import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'

import { QUERY_KEYS } from 'src/constants'
import { accountLanguagesService } from 'src/services/account-languages.service'

export const useAccountLanguagesIds = () => {
  const { accountId } = useParams()

  return useQuery([QUERY_KEYS.ACCCOUNT_LANGUAGES_IDS, accountId], async () =>
    accountId ? accountLanguagesService.getAccountLanguagesIds(accountId) : null,
  )
}
